<template>
  <div class="header header-fixed header-logo-center">
    <router-link class="header-title color-theme" to="/home">
      <slot></slot>
    </router-link>
    <router-link v-if="route.length" :to="route" class="header-icon color-theme header-icon-4">
      <i class="fas fa-plus-circle"></i>
    </router-link>
    <i v-else @click="changeMode" class="header-icon color-theme header-icon-4">
      <i class="fas fa-lightbulb"></i>
    </i>
    <p class="header-icon header-icon-1">
      <i @click="goBack()" class="fas fa-arrow-left"></i>
    </p>
  </div>
</template>

<script>
import global from "@/mixins/global";
import {mapMutations} from "vuex"

export default {
  props: ["route"],
  mixins: [global],
  methods: {
    ...mapMutations(["updateMode"]),
    changeMode() {
      this.updateMode()
    },
  },

  name: "AdminAppBar"
}
</script>

<style scoped>

</style>